'use client';

import { useUnit } from 'effector-react';
import { ActionButton, buttonThemeCyan } from '@nx-frontend/shared/ui/action-button';
import { FloatingPopup } from '@nx-frontend/shared/ui/floating-popup';
import { $themeColors, $themeStyle } from '@nx-frontend/shared/store/portal-theme';
import { updatePortalUserValuesEvent } from '@nx-frontend/shared/store/portal-user-values';

interface IntegrationsIntroPopupProps {
  show: boolean;
  onClose?: () => void;
  onContinue: () => void;
}

export const IntegrationsIntroPopup: React.FC<IntegrationsIntroPopupProps> = ({ show, onClose, onContinue }) => {
  const [themeColors, themeStyle, updatePortalUserValues] = useUnit([
    $themeColors,
    $themeStyle,
    updatePortalUserValuesEvent,
  ]);

  return (
    <FloatingPopup
      show={show}
      position="screen_center"
      className={['w-[682px] !p-0 relative overflow-hidden']}
      onClose={() => {
        updatePortalUserValues({ integrationsIntroShowed: true });
        onClose?.();
      }}
      headerClassName={['absolute top-5 right-5 !p-0']}
    >
      <div className="-top-10" data-cy="integrations-intro-popup">
        <img src={'/assets/img/integrations-intro.png'} alt="" className="w-full" />
        <div className="p-8">
          <h3 className="text-lg font-semibold text-neutral-800">Bring your data to the portal!</h3>
          <p className="text-neutral-500 text-sm font-normal mt-2 mb-6">
            Connect your favorite tools like HubSpot, Asana, and more to display deals, tickets, tasks, and other
            essential data – all in one place. Just authorize the service, choose what you want to see, and it’s ready
            to go!
          </p>
          <div className="flex gap-3 justify-end">
            <ActionButton
              title="See how it works"
              type="stroke"
              size="sm"
              theme={buttonThemeCyan}
              themeColors={themeColors}
              themeStyle={themeStyle}
              className={['rounded-md']}
              href="https://nimbusweb.me/guides/client-portal/displaying-data-from-other-services-hubspot-asana-etc-in-the-portal/"
            />
            <ActionButton
              title="Add and Set up"
              size="sm"
              theme={buttonThemeCyan}
              themeColors={themeColors}
              themeStyle={themeStyle}
              className={['rounded-md']}
              onClick={() => {
                onContinue();
                updatePortalUserValues({ integrationsIntroShowed: true });
              }}
            />
          </div>
        </div>
      </div>
    </FloatingPopup>
  );
};
